import type { AnyAction } from 'redux';

import type { PaleState } from '@/interfaces';
import { appStateReducer } from './appStateActions';
import defaultState from './defaultState';
import { filterReducer } from './filterActions';
import { hotelReducer } from './hotelActions';
import { hotelResultReducer } from './hotelResultActions';
import { mapResultReducer } from './mapResultActions';
import { resultReducer } from './resultActions';

export const reducer = (state: PaleState = defaultState, action: AnyAction) => ({
    ...state,
    filters: filterReducer(state.filters, action),
    results: resultReducer(state.results, action),
    mapResults: mapResultReducer(state.mapResults, action),
    hotelResults: hotelResultReducer(state.hotelResults, action),
    hotel: hotelReducer(state.hotel, action),
    appState: appStateReducer(state.appState, action),
});
